import React, { FC } from 'react';
import styled from 'styled-components';

import { ServiceGroup } from '@/types/serviceGroup';

type Props = {
  children?: never;
  service: ServiceGroup;
};

export const ServiceCard: FC<Props> = (props) => {
  const { service } = props;

  return (
    <Card>
      <Head>
        <img src={service.thumbnailUrl} alt="" />
      </Head>
      <Body>
        <div>{service.name}</div>
        {service.summary && (
          <Description>
            {service.summary.split('\n').map((line, i) => (
              <p key={i}>{line}</p>
            ))}
          </Description>
        )}
      </Body>
    </Card>
  );
};

const CARD_WIDTH = 296;
const CARD_HEIGHT = 285;
const THUMBNAIL_HEIGHT = 160;

const Card = styled.div`
  box-sizing: border-box;
  width: ${CARD_WIDTH}px;
  height: ${CARD_HEIGHT}px;
  overflow: hidden;

  background-color: #fff;
  box-shadow: 0px 1px 4px rgba(110, 110, 110, 0.1);
  border-radius: 4px;

  transition: box-shadow 0.2s ease-in-out;
  :hover {
    box-shadow: 0px 4px 16px rgba(110, 110, 110, 0.4);
  }
`;

const Head = styled.div`
  height: ${THUMBNAIL_HEIGHT}px;
  overflow: hidden;
`;

const Body = styled.div`
  height: ${CARD_HEIGHT - THUMBNAIL_HEIGHT}px;
  padding: 24px;
  color: #292929;
  overflow: hidden;
`;

const Description = styled.div`
  margin-top: 8px;
  font-size: 12px;
  color: #999999;
  > * {
    margin: 0;
  }
`;
